import { Inject, Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { LocalStorage } from '@x/common/storage';
import { ShopCreateWalletPaymentInput } from '@x/schemas/ecommerce';
import { Observable } from 'rxjs';
import {
  CreateShopWalletPaymentGQL,
  ShopWalletGQL,
  ShopWalletsGQL,
} from './gql/shop-wallet.gql.generated';
import { AuthorizationHeaderProvider, AUTHORIZATION_HEADER_PROVIDER } from './types/shop-auth';
import {
  IShopWallet,
  IShopWalletQuery,
  IShopWalletsQuery,
  IShopWalletTransaction,
} from './types/shop-wallet';

@Injectable()
export class ShopWalletService {
  constructor(
    private localStorage: LocalStorage,
    private shopWalletGQL: ShopWalletGQL,
    private shopWalletsGQL: ShopWalletsGQL,
    private createWalletPaymentGQL: CreateShopWalletPaymentGQL,
    @Inject(AUTHORIZATION_HEADER_PROVIDER)
    private authHeader: AuthorizationHeaderProvider,
  ) {
    if (!authHeader) throw new Error('authHeader Provider is required');
  }

  fetchWallet(query: IShopWalletQuery): Observable<IShopWallet | null | undefined> {
    return this.shopWalletGQL
      .fetch(query, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopWallet));
  }

  fetchWallets(query: IShopWalletsQuery): Observable<IShopWallet[]> {
    return this.shopWalletsGQL
      .fetch(query, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopWallets));
  }

  createWalletPayment(input: ShopCreateWalletPaymentInput): Observable<IShopWalletTransaction> {
    return this.createWalletPaymentGQL
      .mutate({ input }, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopCreateWalletPayment));
  }
}
